import {
  CANCEL_CREATE_USERS,
  CLEAR_USERS_FILTER,
  GET_USER_BY_ID_FAILURE,
  GET_USER_BY_ID_REQUEST,
  GET_USER_BY_ID_SUCCESS,
  GET_USER_FAILURE,
  GET_USER_REQUEST,
  GET_USER_SUCCESS,
  GET_USERS_FAILURE,
  GET_USERS_REQUEST,
  GET_USERS_SUCCESS,
  PATCH_USERS_FAILURE,
  PATCH_USERS_REQUEST,
  PATCH_USERS_SUCCESS,
  POST_RESEND_EMAIL_FAILURE,
  POST_RESEND_EMAIL_REQUEST,
  POST_RESEND_EMAIL_SUCCESS,
  POST_USERS_FAILURE,
  POST_USERS_REQUEST,
  POST_USERS_SUCCESS,
  SET_USERS_FILTER,
} from '../actions/users'

export const getUser = (
  state = {
    isFetching: false,
    user: null,
    errorMessage: null,
  },
  action
) => {
  switch (action.type) {
    case GET_USER_REQUEST:
      return {
        ...state,
        user: null,
        isFetching: true,
        errorMessage: null,
      }
    case GET_USER_SUCCESS:
      return {
        ...state,
        errorMessage: null,
        isFetching: false,
        user: action.response,
      }
    case GET_USER_FAILURE:
      return {
        ...state,
        errors: null,
        user: null,
        isFetching: false,
        errorMessage: action.error,
      }
    default:
      return state
  }
}

export const getUserById = (
  state = {
    isFetching: false,
    user: null,
    errorMessage: null,
  },
  action
) => {
  switch (action.type) {
    case GET_USER_BY_ID_REQUEST:
      return {
        ...state,
        user: null,
        isFetching: true,
        errorMessage: null,
      }
    case GET_USER_BY_ID_SUCCESS:
      return {
        ...state,
        errorMessage: null,
        isFetching: false,
        user: action.response,
      }
    case GET_USER_BY_ID_FAILURE:
      return {
        ...state,
        errors: null,
        user: null,
        isFetching: false,
        errorMessage: action.error,
      }
    default:
      return state
  }
}

export const getUsers = (
  state = {
    isFetching: false,
    results: null,
    errorMessage: null,
  },
  action
) => {
  switch (action.type) {
    case GET_USERS_REQUEST:
      return {
        ...state,
        results: null,
        isFetching: true,
        errorMessage: null,
      }
    case GET_USERS_SUCCESS:
      return {
        ...state,
        errorMessage: null,
        isFetching: false,
        results: action.response,
      }
    case GET_USERS_FAILURE:
      return {
        ...state,
        errors: null,
        results: null,
        isFetching: false,
        errorMessage: action.error,
      }
    default:
      return state
  }
}

export const createUser = (
  state = {
    isFetching: false,
    results: null,
    errorMessage: null,
    errors: {},
  },
  action
) => {
  switch (action.type) {
    case POST_USERS_REQUEST:
      return {
        ...state,
        results: null,
        isFetching: true,
        errorMessage: null,
      }
    case POST_USERS_SUCCESS:
      return {
        ...state,
        errorMessage: null,
        isFetching: false,
        results: action.response,
      }
    case POST_USERS_FAILURE:
      return {
        ...state,
        errors: action.details,
        results: null,
        isFetching: false,
        errorMessage: action.error,
      }
    case CANCEL_CREATE_USERS:
      return {
        ...state,
        errors: [],
        results: null,
        isFetching: false,
        errorMessage: {},
      }
    default:
      return state
  }
}

export const updateUser = (
  state = {
    isFetching: false,
    results: null,
    errorMessage: null,
    errors: {},
  },
  action
) => {
  switch (action.type) {
    case PATCH_USERS_REQUEST:
      return {
        ...state,
        results: null,
        isFetching: true,
        errorMessage: null,
      }
    case PATCH_USERS_SUCCESS:
      return {
        ...state,
        errorMessage: null,
        isFetching: false,
        results: action.response,
      }
    case PATCH_USERS_FAILURE:
      return {
        ...state,
        errors: action.details,
        results: null,
        isFetching: false,
        errorMessage: action.error,
      }
    default:
      return state
  }
}

export const resendEmail = (
  state = {
    isFetching: false,
    results: null,
    errorMessage: null,
    errors: {},
  },
  action
) => {
  switch (action.type) {
    case POST_RESEND_EMAIL_REQUEST:
      return {
        ...state,
        results: null,
        isFetching: true,
        errorMessage: null,
      }
    case POST_RESEND_EMAIL_SUCCESS:
      return {
        ...state,
        errorMessage: null,
        isFetching: false,
        results: action.response,
      }
    case POST_RESEND_EMAIL_FAILURE:
      return {
        ...state,
        errors: action.details,
        results: null,
        isFetching: false,
        errorMessage: action.error,
      }
    default:
      return state
  }
}
export const defaultUsersFilter = {
  name: '',
  page: 1,
  business_id: '',
  groups: '',
  is_active: true,
}
export const usersFilter = (state = { filter: defaultUsersFilter }, action) => {
  switch (action.type) {
    case SET_USERS_FILTER:
      return { ...state, filter: { ...action.filter } }
    case CLEAR_USERS_FILTER:
      return { ...state, filter: { ...defaultUsersFilter } }
    default:
      return state
  }
}
